import type { ApiStatus } from '@amfam/shared/models/lib/api/api-status.model';

import { ClaimFaqAction, ClaimFaqActionTypes } from './claim-faq.actions';

export const CLAIMFAQ_FEATURE_KEY = 'claimFaq';

export interface ClaimFaqState {
  richContent: string | null;
  loading: boolean;
  status: ApiStatus | null;
  loaded: boolean;
  hasError: boolean;
}

export const initialState: ClaimFaqState = {
  richContent: null,
  loading: false,
  status: null,
  loaded: false,
  hasError: false
};

export function claimFaqReducer(
  state: ClaimFaqState = initialState,
  action: ClaimFaqAction
): ClaimFaqState {
  switch (action.type) {
    case ClaimFaqActionTypes.LOAD_CLAIM_FAQ:
      return { ...state, ...initialState, loading: true, loaded: false };

    case ClaimFaqActionTypes.LOAD_CLAIM_FAQ_SUCCESS:
      return { ...state, ...action.payload, loading: false, loaded: true };

    case ClaimFaqActionTypes.LOAD_CLAIM_FAQ_FAIL:
      return {
        ...state,
        status: action.payload?.error.status ?? null,
        loading: false,
        loaded: true,
        hasError: true
      };

    default:
      return state;
  }
}
